import CurrencySymbol from "@/util/currency";
import {
  Slider 
} from "antd";
import {
  useCallback, useEffect, useMemo, useState 
} from "react";
import classes from "./priceSelect.module.css";

const PriceSelect = (props) => {
  const {
    prices,
    filterApi,
    filterState,
    group,
    currentCurrencyCode,
    onApply
  } = props;

  const {
    removeGroup, addItem 
  } = filterApi;

  const [min, max] = useMemo(() => {
    const values = [];

    if (prices) {
      prices.forEach((price) => {
        values.push(...price.value.split("_").map((temp) => parseInt(temp, 10)));
      });
    }

    return [Math.min(...values), Math.max(...values)];
  }, [prices, filterState]);

  const [currentMin, setCurrentMin] = useState(null);

  const [currentMax, setCurrentMax] = useState(null);

  useEffect(() => {
    if (filterState) {
      const value = filterState.values().next().value;

      if (value) {
        setCurrentMin(value[0]);
        setCurrentMax(value[1]);
      }
    } else {
      setCurrentMin(min);
      setCurrentMax(max);
    }
  }, [min, max, filterState]);

  const onChange = (value) => {
    setCurrentMin(value[0]);
    setCurrentMax(value[1]);
  };

  const onAfterChange = useCallback(
    (value) => {
      removeGroup({
        group 
      });
      addItem({
        group, item: [value[0], value[1]] 
      });

      if (typeof onApply === "function") {
        onApply(group, [value[0], value[1]]);
      }
    },
    [removeGroup, addItem, group]
  );

  return (
    <div className={classes.priceSelect}>
      <div className={classes.rangeContainer}>
        <span className={classes.priceSelectText}>
          {CurrencySymbol[currentCurrencyCode]}
          {currentMin}
        </span>
        <span className={classes.priceSelectText}>
          {CurrencySymbol[currentCurrencyCode]}
          {currentMax}
        </span>
      </div>
      <div className={classes.sliderContainer}>
        <Slider
          range
          step={1}
          min={min}
          max={max}
          value={[currentMin, currentMax]}
          onChange={onChange}
          onAfterChange={onAfterChange}
          tooltip={{
            open: false 
          }}
        />
      </div>
    </div>
  );
};

export default PriceSelect;
